import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonGroup from '@prism/buttongroup';

class PrismButtonGroup extends React.PureComponent {
    static propTypes = {
        tag: PropTypes.string,
        className: PropTypes.string,
        buttonGroupClassName: PropTypes.string,
        size: PropTypes.string,
        vertical: PropTypes.bool
    };

    static defaultProps = {
        tag: 'div',
        vertical: false
    };

    render() {
        const containerClassName = classNames(
            'prism-sandbox',
            this.props.className
        );

        const buttonGroupClassName = classNames(
            'prism-button-group',
            this.props.buttonGroupClassName
        );

        return (
            <div className={containerClassName}>
                <ButtonGroup
                    {...this.props}
                    className={buttonGroupClassName}
                >
                    {this.props.children}
                </ButtonGroup>
            </div>
        );
    }
}

export default PrismButtonGroup;
